<template>
  <div class="im_socket" :class="{ showMove: isShow }" v-drag-handle="{ handle: '.header' }" ref="socket">
    <div class="left">
      <i :class="!isShow ? 'el-icon-arrow-left' : 'el-icon-arrow-right'" @click="showAll"></i>
    </div>
    <div class="right" v-show="!isShow">
      客服外呼
      <i class="iconfont iconcaidan-95duanhao" style="margin-top: 15px;display: inline-block;"></i>
    </div>
    <div class="content" v-show="isShow">
      <div class="header" >
        客服外呼 (拖拽移动位置)
      </div>
      <div class="ifream">
        <iframe
          id="child"
          :src="iframeSrc"
          allow="microphone;camera;midi;encrypted-media;"
          width="700"
          height="130"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script >
import { mapGetters } from 'vuex'
const VUE_APP_IM_SOCKET = process.env.VUE_APP_IM_SOCKET

export default {
  name: 'ImSocket',
  computed: {
    ...mapGetters(['user']),
    iframeSrc() {
      return `${VUE_APP_IM_SOCKET}?account=${this.user?.code}&agentSystem=OUTSOURCE`
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  created() {
    window.addEventListener('message', messageEvent => {
      // console.error('messageEvent', messageEvent)
      // const systemName = location.pathname.split('/')[2]
      // 263电话条 响铃时是否跳转相对页面
      if (messageEvent.data.type === 'incoming') {
        this.isShow = true
        // Vue.prototype.$showMessageDialog.open(window.vueStorage[systemName])
      }
      // 263电话条 挂断电话 电话
      if ((messageEvent.data.type === 'ended' || messageEvent.data.type === 'failed')) {
        // Vue.prototype.$showMessageDialog.close()
        // store.commit('SET_ARTICLE_PHONE', messageEvent.data.type)
        // this.isShow = false
      }
      // 263电话条 呼出电话 电话
      if (messageEvent.data.type === 'outgoing') {
        this.isShow = true
        // store.commit('SET_ARTICLE_PHONE', messageEvent.data.type)
      }
      // 263电话条 传递运单号数据 跳转到录单页面
      if (messageEvent.data.type === 'waybill') {
        // Vue.prototype.$showMessageDialog.close()
        const msg = messageEvent.data.params
        if (msg.waybillNo || msg.caller) {
          window.RXGW.subject.next({
            target: ['gateway'],
            type: 'router',
            data: {
              to: {
                path: '/app/serviceQualityIndex/NoteTaking',
                query: {
                  ...msg
                }
              }
            }
          })
        }
      }
    })
  },
  mounted() {},
  methods: {
    showAll() {
      this.isShow = !this.isShow
      if (!this.isShow) {
        this.$refs.socket.style.top = '20vh'
        this.$refs.socket.style.left = 'auto'
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.im_socket {
  width: auto;
  position: fixed;
  z-index: 2008;
  top: 20vh;
  right: 0px;
  // transform: translateY(-50%);
  display: flex;
  align-items: center;
  .left {
    width: 12px;
    height: 40px;
    background: #e60012;
    border-radius: 8px 0px 0px 8px;
    color: white;
    line-height: 40px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: #c40010;
    }
  }
  .right {
    background: #e60012;
    padding: 18px 9px;
    // border-radius: 5px;
    font-size: 14px;
    color: white;
    font-weight: 600;
    line-height: 20px;
    width: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  > .content {
    width: 565px;
    height: auto;
    background: #e60012;
    border-radius: 4px;
    overflow: hidden;
    .header {
      height: 42px;
      line-height: 42px;
      color: white;
      box-sizing: border-box;
      padding-left: 20px;
      cursor: move;
      border-bottom: 1px solid white;
      z-index: 1000
    }
  }
}
.showMove {
  width: 575px;
}
iframe {
  transform: translate(-9%, -3%);
  height: 95px;
  overflow: hidden;
}
</style>
